import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class StaffService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getGroups() {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/groups`);
        if (result) {
            return {
                data: result.data,
                groupCd: result.headers.login_group_code || "",
                shatenCd: result.headers.login_shaten_code || ""
            };
        } else {
            return this.authService.handleError(error, "getGroups");
        }
    }

    public async getStaff(param: any, sknWorkRole: any = null) {
        let q = "";
        let query: string[] = [];
        if (param) {
           
            Object.keys(param).forEach((key: string) => {
                if (param[key]) {
                    query.push(`${key}=${param[key]}`);
                }
            });
            
        }
        if (sknWorkRole) {
            query.push(`sknWorkRole=${sknWorkRole}`);
        }
        if (query.length) {
            q = `?${query.join("&")}`;
        }
        let path = `${this.baseAPI}/admin/staff${q}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            return this.authService.handleError(error, "getStaff");
        }
    }

    public async getStaffEachKyoten(param: any, sknWorkRole: any = null) {
        let q = "";
        let query: string[] = [];
        if (param) {
           
            Object.keys(param).forEach((key: string) => {
                if (param[key]) {
                    query.push(`${key}=${param[key]}`);
                }
            });
            
        }
        if (sknWorkRole) {
            query.push(`sknWorkRole=${sknWorkRole}`);
        }
        if (query.length) {
            q = `?${query.join("&")}`;
        }
        let path = `${this.baseAPI}/admin/staffEachKyoten${q}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            return this.authService.handleError(error, "getStaff");
        }
    }

    // public async getStaffByRole(kyotenCd: string, roleKbn: number) {
    //     let path = `${this.baseAPI}/admin/staff`;
    //     if (kyotenCd && roleKbn) {
    //         path += "?kyotenCd=" + kyotenCd;
    //         path += "&sknWorkRole=" + roleKbn;
    //     }
    //     if (!kyotenCd && roleKbn) {
    //         path += "?sknWorkRole=" + roleKbn;
    //     }
    //     const { result, error } = await this.commonService.get(path);
    //     if (result) {
    //         return result.data;
    //     } else {
    //         return this.authService.handleError(error, "getStaffByRole");
    //     }
    // }

    async saveStaffRole(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/staff`, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveStaffRole');
            return;
        }
    }

    // ============================





}
